// Bouton "Filtrer" pour ouvrir les filtres en version mobile
const filtersToggler = document.getElementById('toggle-adherents-filters');
const categoryTree = document.getElementById('adherents-filter');

if (typeof(filtersToggler) != 'undefined' && filtersToggler != null) {
  filtersToggler.addEventListener('click', () => {
    const isActive = filtersToggler.classList.contains('active');

    // Ouvrir celui cliqué
    if (!isActive) {
      filtersToggler.classList.add('active');
      filtersToggler.setAttribute('aria-expanded', 'true');
      categoryTree.classList.add('filters--opened')
    } else {
      filtersToggler.classList.remove('active');
      filtersToggler.setAttribute('aria-expanded', 'false');
      categoryTree.classList.remove('filters--opened')
    }
  });
}

const form = document.getElementById('filter-adherent');

if (form) {
  form.addEventListener('submit', (e) => {
    e.preventDefault();

    const params = new URLSearchParams();

    const typologies = [...form.querySelectorAll('input[name="filter-typologies"]:checked')]
      .map(i => i.value)
      .join(',');
    if (typologies) params.set('filter-typologies', typologies);

    const localisations = [...form.querySelectorAll('input[name="filter-localisations"]:checked')]
      .map(i => i.value)
      .join(',');
    if (localisations) params.set('filter-localisations', localisations);

    const action = form.getAttribute('action') || window.location.pathname;
    window.location.href = `${action.split('?')[0]}?${params.toString()}`;
  });
}

